import React from 'react';
import { Dialog, Slide } from '@mui/material';
import SqlRunnerSourceForm from './SqlRunnerSourceForm';
import { TransitionProps } from '@mui/material/transitions';
import { UserConfirmationForModals } from 'new/components/UserConfirmationForModals';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { loadSqlAutomationsPipelines } from 'js/actions/pipelines';
import { saveState } from 'new/state/hashedState/action';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export type ModalELTScriptRunnerSourceFormProps = {
  id?: number;
  connectionTypes?: string[];
  onDismiss?: (source: any) => void;
  onClose?: () => void;
  flowType?: string;
  parentDataSetId?: number;
  open: boolean;
  queryParams?: Record<string, string>;
};

const paperStyle = {
  style: {
    background: 'transparent',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    borderRadius: '8px',
    padding: '49px',
  },
};

/**
 * Modal wrapper for the SQL Runner (ELT Script Runner) source form.
 */
const ModalELTScriptRunnerSourceForm = (props: ModalELTScriptRunnerSourceFormProps) => {
  const dispatch = useAppDispatch();
  const {
    id,
    onDismiss,
    open,
    flowType = 'streaming',
    parentDataSetId,
    onClose,
    queryParams,
  } = props;

  const onCloseHandler = (event: unknown = null, reason: string = '') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    if (onClose) {
      setTimeout(() => {
        onClose();
      }, 500);
    }
  };

  const onDismissForm = (source: any) => {
    const flowNodeId = source?.flow_node_id ?? source?.origin_node_id ?? undefined;
    if (flowNodeId != null) {
      dispatch(saveState('flows.selected', flowNodeId));
    }
    if (source != null) {
      dispatch(loadSqlAutomationsPipelines());
    }
    onCloseHandler();
    onDismiss?.(source);
  };

  return (
    <>
      <Dialog
        fullScreen
        keepMounted={false}
        open={open}
        onClose={onCloseHandler}
        PaperProps={paperStyle}
        TransitionComponent={Transition}
      >
        <SqlRunnerSourceForm
          id={id}
          flowType={flowType}
          parentDataSetId={parentDataSetId}
          queryParams={queryParams}
          onDismiss={onDismissForm}
        />
      </Dialog>
      <UserConfirmationForModals open={open} onConfirm={() => onDismissForm(null)} />
    </>
  );
};

export default ModalELTScriptRunnerSourceForm;
